/** Available statuses for the restaurant */
export class Status {
	active:boolean;
	deliveryEnabled: boolean;
	pickupEnabled: boolean;

	/**
	 * Constructor
	 * @param isEnabled Restaurant should be up and running, and being shown to the end users. Only set this true if you are ready to start receiving orders
	 * @param deliveryEnabled Whether the restaurant is taking delivery orders or not
	 * @param pickupEnabled Whether the restaurant is taking pickup orders or not
	 */
	constructor(active:boolean, deliveryEnabled: boolean, pickupEnabled: boolean) {
		this.active = active;
		this.deliveryEnabled = deliveryEnabled;
		this.pickupEnabled = pickupEnabled;
	}

	/** Converts this object into a format that can be saved on our database (DynamoDB) */
	toAWSObject(){
		let statusObj = {
			"active":this.active,
			"deliveryEnabled":this.deliveryEnabled,
			"pickupEnabled":this.pickupEnabled,
		};
		return statusObj;
	}

	static generateDefaultStatus(){
		return new Status(false, true, true);
	}

	static newFromAws(awsStatusItem:any):Status {
		if(awsStatusItem!=null){
			const active 			= awsStatusItem.active==null?false:awsStatusItem.active;
			const deliveryEnabled 	= awsStatusItem.deliveryEnabled==null?false:awsStatusItem.deliveryEnabled;
			const pickupEnabled 	= awsStatusItem.pickupEnabled==null?false:awsStatusItem.pickupEnabled;
			return new Status(active, deliveryEnabled, pickupEnabled);
		}else{
			return Status.generateDefaultStatus();
		}
	}
}